import { AlarmLevel } from '../../models/enum';
import { mapMarkerIcons } from './mapMarkerIcons';

export const getMarkerIcon = (alarmLevel?: AlarmLevel) => {
    let icon = mapMarkerIcons.defaultIcon;
    if (alarmLevel !== undefined && alarmLevel !== null) {
        switch (alarmLevel) {
            case AlarmLevel.Information:
                icon = mapMarkerIcons.informationIcon;
                break;
            case AlarmLevel.Warning:
                icon = mapMarkerIcons.warningIcon;
                break;
            case AlarmLevel.Critical:
                icon = mapMarkerIcons.criticalIcon;
                break;
        }
    }
    return icon;
};
